import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, MenuOptions, MenuItem, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit, rentRange, leadStatus } from "../../Config";
import { MdEdit, MdModeEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { IoMdMore, IoIosCreate } from "react-icons/io";
import { FaFemale, FaMale, FaUser } from "react-icons/fa";
import { getLeadRentRange, getLeadSource, handleCopy } from "../../helpers"
import moment from "moment";
import { FaLink } from "react-icons/fa";
import { IoCopySharp } from "react-icons/io5";

const Table = ({
    apiData,
    setIsShowEditLead,
    setSelectedData,
    setLinkProperty,
    setViewDetail,
    setIsAssignStaff
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);

    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const edit = (item) => {
        setIsShowEditLead(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const linkUnlink = (item) => {
        setLinkProperty(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const assignStaff = (item) => {
        setIsAssignStaff(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const viewDetail = (item) => {
        setViewDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };


    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">
                        <MenuItem
                            title="View Lead"
                            // onClick={() => {
                            //     edit(item)
                            // }}
                            onClick={() => viewDetail(item)}
                        >
                            <MdOutlineRemoveRedEye className="text-gray-700 " /> View Lead
                        </MenuItem>

                        <MenuItem
                            onClick={() => {
                                linkUnlink(item)
                            }}
                        >
                            <FaLink className="text-gray-700 " /> Link - Unlink
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                assignStaff(item)
                            }}
                        >
                            <FaUser className="text-gray-700 " /> Assign Staff
                        </MenuItem>
                    </MenuOptions>
                )
                }
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper >
        );
    };
    useEffect(() => {
        if (apiData) {

            const tempData = apiData.map((item) => ({
                // mobileNo: item.mobileNo,
                visitDate: <span className='text-gray-600 text-sm'>{item.visitDate}</span>,
                visitTime: <span className='text-gray-600 text-sm'>{item.visitTime}</span>,
                name: getName(item),
                rentRange: getLeadRentRange(item.rentRange),
                source: getLeadSource(item.source),
                // property: item.property,
                gender: getGender(item.gender),
                status: getStatus(item),
                action: ActionBtns(item),
                description: item.description,
                date: (
                    <span className="text-gray-600 text-sm">
                        {moment(item.createdAt).format("DD, MMM YY hh:mm A")}
                    </span>
                ),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getStatus = (item) => {
        if (item.status === 1) {
            return <div>
                <span className={`text-sm font-semibold text-blue-500`}>
                    {"New"}
                </span>

            </div>;
        } else if (item.status === 2) {
            return <div>
                <span className={`text-sm font-semibold text-yellow-500`}>
                    {"Follow Up"}
                </span>
                {item.visitDateTime &&
                    <div className="text-xs text-gray-500">
                        {moment(item.visitDateTime).format("DD, MMM YY hh:mm A")}
                    </div>}
            </div>;
        } else if (item.status === 3) {
            return <div>
                <span className={`text-sm font-semibold text-green-500`}>
                    {"Visit Scheduled"}
                </span>
                <div className="text-xs text-gray-500">
                    {moment(item.visitDateTime).format("DD, MMM YY hh:mm A")}
                </div>
            </div>;
        } else if (item.status === 4) {
            return <div>
                <span className={`text-sm font-semibold text-purple-500`}>
                    {"Visit Done"}
                </span>
            </div>;
        } else if (item.status === 5) {
            return <div>
                <span className={`text-sm font-semibold text-teal-500`}>
                    {"Moved In"}
                </span>
            </div>;
        } else if (item.status === 6) {
            return <div>
                <span className={`text-sm font-semibold text-gray-500`}>
                    {"Not Interested"}
                </span>
            </div>;
        } else if (item.status === 7) {
            return <div>
                <span className={`text-sm font-semibold text-amber-500`}>
                    {"Contacted"}
                </span>
            </div>;
        } else if (item.status === 8) {
            return <div>
                <span className={`text-sm font-semibold text-lime-500`}>
                    {"Interested"}
                </span>
            </div>;
        } else if (item.status === 9) {
            return <div>
                <span className={`text-sm font-semibold text-emerald-500`}>
                    {"Invalid"}
                </span>
            </div>;
        } else if (item.status === 10) {
            return <div>
                <span className={`text-sm font-semibold text-cyan-500`}>
                    {"Onhold"}
                </span>
            </div>;
        } else if (item.status === 11) {
            return <div>
                <span className={`text-sm font-semibold text-sky-500`}>
                    {"Not Answered"}
                </span>
            </div>;
        } else if (item.status === 12) {
            return <div>
                <span className={`text-sm font-semibold text-red-500`}>
                    {"Lost"}
                </span>
            </div>;
        } else {
            return <div>
                <span className={`text-sm font-semibold text-gray-500`}>
                    {"Other"}
                </span>

            </div>;
        }
    };

    const getName = (item) => {
        return (
            <UserImageWrapper>
                {item.gender === 1 ? (
                    <FaMale className="text-gray-400 w-8 h-8" />
                ) : (
                    <FaFemale className="text-gray-400 w-8 h-8" />
                )}
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {item?.name?.charAt(0).toUpperCase() + item?.name?.slice(1)}{" "}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.mobile}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.mobile);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };


    const getGender = (gender) => {
        if (gender === 1) {
            return <p>Male</p>;
        } else if (gender === 2) {
            return <p>Female</p>;
        }
    };


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Rent Range",
                    accessor: "rentRange",
                },
            ];
        }
        return [
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Rent Range",
                accessor: "rentRange",
            },
            {
                Header: "Source",
                accessor: "source",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Date",
                accessor: "date",
            },

            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );


    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Gender:</strong>{" "}
                                                    {data[rowIndex].gender}
                                                </li>

                                                <li>
                                                    <strong>Rent Range:</strong>{" "}
                                                    {data[rowIndex].rentRange}
                                                </li>
                                                <li>
                                                    <strong>Source:</strong>{" "}
                                                    {data[rowIndex].source}
                                                </li>

                                                <li className="flex gap-2">
                                                    <strong>Status:</strong> {data[rowIndex].status}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Date:</strong> {data[rowIndex].date}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
// const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
// const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Inprogress = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Resolve = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;

export default Table;

